<template>
  <Dialog
    :is-dialog-open="isDialogOpen"
    max-width="700"
    :close-dialog="closeDialog"
    dialog-title="Duplicar formulário"
  >
    <v-form
      ref="formRef"
      class="multi-row-validation"
      @submit.prevent="handleSubmitBtnClick"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="nome"
            label="Nome"
            dense
            outlined
            validate-on-blur
            hide-details="auto"
            :rules="[validators.required]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="descricao"
            label="Descrição"
            placeholder="Descrição"
            dense
            outlined
            auto-grow
            validate-on-blur
            hide-details="auto"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-center"
        >
          <v-btn
            color="secondary"
            class="mr-4"
            outlined
            type="reset"
            @click="resetFormAndCloseDialog"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            type="submit"
          >
            <v-progress-circular
              v-if="loading"
              class="mx-3"
              indeterminate
              color="secundary"
            />
            <span v-else>Salvar</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </Dialog>
</template>

<script>
import { ref } from '@vue/composition-api'
import Vue from 'vue'
import { required } from '@/@core/utils/validation'
import Dialog from '@/components/dialog/Dialog.vue'
import FormularioService from '@/services/modules/FormularioService'
import useDialog from '@/composables/useDialog'

export default {
  components: {
    Dialog,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    formularioId: {
      type: Number,
      required: true,
    },
  },

  emits: ['update:isDialogOpen'],

  setup(props, { emit }) {
    const { formRef, loading, resetForm, validateForm, FORM_ERROR, closeDialog, emitRefetchData } = useDialog(emit, 'isDialogOpen')

    function resetFormAndCloseDialog() {
      resetForm()
      closeDialog()
    }

    const nome = ref('Duplicado_XXXXXXX')
    const descricao = ref('')

    async function handleSubmitBtnClick() {
      if (loading.value) return
      if (!validateForm()) {
        Vue.$toast(FORM_ERROR)

        return
      }

      try {
        loading.value = true

        await FormularioService.duplicarFormulario(props.formularioId, {
          nome: nome.value,
          descricao: descricao.value,
        })

        resetFormAndCloseDialog()
        emitRefetchData()
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      closeDialog,
      resetFormAndCloseDialog,
      nome,
      descricao,
      handleSubmitBtnClick,
      validators: {
        required,
      },
    }
  },
}
</script>
